import { ActionService } from 'dashboard-services/services';

export default (() => {

  const CHANGE_VALUE = 'CHANGE_VALUE_CODE_EDITOR'
  const changeValue = ActionService.makeActionCreator(CHANGE_VALUE, 'value', 'name')

  return {
    changeValue,
    CHANGE_VALUE
  }
})()